<template>
  <ion-page>
    <master-layout pageTitle="لیست سفارشات مشتری">
        <ion-card-content>
          <div class="space-between">
            <div>
              <date-input v-model="s_date" placeholder="از تاریخ.."></date-input>
<!--              <date-picker @change="changeSDate" placeholder="از تاریخ.." only-date="false" name="s_date" v-model="s_date" class="form-control"></date-picker>-->
            </div>
            <div >
              <date-input v-model="e_date" placeholder="از تاریخ.."></date-input>
<!--              <date-picker @change="changeEDate" placeholder="تا تاریخ.." only-date="false" name="e_date" v-model="e_date" class="form-control"></date-picker>-->
            </div>
          </div>
          <div>
            <select class="form-control" name="status" v-model="status">
              <option value="">همه</option>
              <option value="-2">درخواست</option>
              <option value="-1">تایید نشده</option>
              <option value="0">لغو شده</option>
              <option value="1">در حال پردازش</option>
              <option value="2">ارسال شده</option>
              <option value="3">تحویل شده</option>
              <option value="4">کاملا مرجوع شده</option>
              <option value="5">بخشی مرجوع شده</option>
            </select>
          </div>
          <DataTable card="true" auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
   IonCardContent, IonPage
} from "@ionic/vue";
import DateInput from "@/components/DateInput.vue";


export default {
  data()
  {
    return {
      id: null,
      status: null,
      s_date: null,
      e_date: null,
      route: null,
      headers:[
        'شماره سفارش',
        'نام مشتری',
          'تاریخ ثبت',
        'مبلغ',
        'وضعیت',
        'امکانات'
      ]
    };
  },
  async mounted()
  {
    // this.id = this.$route.params.id;
    this.status = this.$route.query.status;
    // this.route = 'order/ListAjax';
   this.init();
  },
  components: {
    DateInput,
     IonCardContent, DataTable, IonPage
  },
  methods:{
    init(){
      const status = this.status;
      const s_date = this.s_date;
      const e_date = this.e_date;
      let route = 'order/ListAjax?t=1';
      if (status)
        route+='&status='+status;
      if (s_date)
        route+='&s_date='+s_date;
      if (e_date)
        route+='&e_date='+e_date;
      this.route = route;
    },
    changeSDate(date)
    {
      this.s_date = date;
      this.init();
    },
    changeEDate(date)
    {
      this.e_date = date;
      this.init();
    },
  },
  watch: {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('order/list') >= 0 && oldUrl.toLowerCase().indexOf('order/list') < 0)
        {
          this.route = null;
          this.status = this.$route.query.status;
          this.init()
        }
      },
      deep:true
    },
    s_date : {
      handler()
      {
        this.init();
      }
    },
    e_date : {
      handler()
      {
        this.init();
      }
    },
    // e_date : function (){
    //   this.route = null;
    //   this.init();
    // },
    // s_date : function (){
    //   console.log('sddddddddd')
    //   this.route = null;
    //   this.init();
    // },
    status : function (){
      this.route = null;
      this.init();
    }
    // '$route.path': {
    //   handler(newUrl)
    //   {
    //     if (newUrl.indexOf('order/list') >= 0)
    //     {
    //       this.st = this.$route.query.st;
    //       this.route = 'order/listAjax?st='+this.st+'&t=' + (new Date().getTime())
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
.space-between
{
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.space-between .label
{
  min-width: 30%;
}

</style>